import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { Common } from 'ws-scripts/modules/common';
import './MyCarsButton.scss';

class MyCarsButton extends React.Component {
	trackEvent(action) {
		this.props.trackGa({
			element: 'Favorite button',
			result: `Favorite ${action}`,
			widgetState: 'default'
		});
	}
	render() {
		const {
			myCars: { savedVehicles },
			myCarsSaveButtonClasses
		} = this.props;

		let component = null;

		if (savedVehicles) {
			const { uuid, transparent } = this.props;

			const containerClasses = ['mycars-buttons'];
			if (!transparent) {
				containerClasses.push('mr-4');
			}

			const classes = new Set([
				'btn-mycars-save',
				'd-flex',
				'align-items-center',
				'btn-no-decoration',
				'btn-small',
				//	myCars classes are used to attach remove/save vehicle listeners
				//	alternates with 'mycars-saved-btn' which signifies a click should remove the saved vehicle
				'mycars-save-btn'
			]);

			if (transparent) {
				classes.add('p-4 pr-3');
			}

			if (myCarsSaveButtonClasses) {
				classes.add(myCarsSaveButtonClasses);
			}

			const savedVehicle = savedVehicles
				? savedVehicles.find(vehicle => {
						return vehicle.itemUUID === uuid;
				  })
				: null;

			const buttonLabel = savedVehicle ? 'SAVED' : 'SAVE';
			const action = savedVehicle ? 'removed' : 'added';
			const dataMessage = savedVehicle
				? '#ddc-mobile-mycars-remove'
				: '#ddc-mobile-mycars';
			const dataAction = savedVehicle ? 'remove' : 'save';

			if (savedVehicle) {
				classes.add('saved');
				// alternated save / saved class to trigger removeVehicle logic on click
				classes.delete('mycars-save-btn');
				classes.add('mycars-saved-btn');
			}
			const dataAttributes = {
				'data-id': uuid,
				'data-message': dataMessage
			};

			dataAttributes[`data-mycars-${dataAction}`] = '';

			// format-js puts the closing tag of the <path> element on the wrong line
			// then the linter fails because this is invalid. TODO: Have Syntropy fix this
			/* eslint-disable react/jsx-closing-bracket-location */
			component = (
				<Common
					render={({ labels }) => {
						const iconSize = '24';

						return (
							<div className={containerClasses.join(' ')}>
								<Button
									className={[...classes].join(' ')}
									bsStyle={transparent ? 'link' : 'default'}
									onClick={() => {
										this.trackEvent(action);
									}}
									{...dataAttributes}
								>
									<svg
										version="1.1"
										xmlns="http://www.w3.org/2000/svg"
										width={iconSize}
										height={iconSize}
										viewBox="0 0 24 24"
										className="ddc-icon-mycars-favorite"
									>
										<path d="M18.2,22L12,18.2L5.8,22L7,14.5l-5-5l6.9-1.2L12,2l3.2,6.2L22,9.5l-5,5L18.2,22z" />
									</svg>
									{!transparent && (
										<span className="pl-2">
											{labels.get(buttonLabel)}
										</span>
									)}
								</Button>
							</div>
						);
					}}
				/>
			);
		}

		return component;
	}
}

MyCarsButton.propTypes = {
	uuid: PropTypes.string.isRequired,
	transparent: PropTypes.bool,
	trackGa: PropTypes.func.isRequired,
	myCars: PropTypes.shape({
		savedVehicles: PropTypes.array
	}).isRequired,
	myCarsSaveButtonClasses: PropTypes.string
};

MyCarsButton.defaultProps = {
	transparent: false,
	myCarsSaveButtonClasses: ''
};

export default MyCarsButton;



// WEBPACK FOOTER //
// ./src/components/MyCarsButton.jsx